import type { GtmListIdTypeT } from '@vs-shop/schemas/gtm/list-types';
import { Effect } from 'effect';

import {
  createSelectItemPayloadFromProductCard,
  type HasSelectItemFields,
} from '../../utils/gtm/create/select-item';
import { sendGtmEvent } from '../../utils/gtm/gtm';

export type SendSelectItemEventData = {
  product: HasSelectItemFields;
  listType: GtmListIdTypeT;
};

export default function sendSelectItemEvent(data: SendSelectItemEventData) {
  return Effect.gen(function* () {
    const payload = yield* createSelectItemPayloadFromProductCard(data.product, data.listType);

    return yield* sendGtmEvent(payload, true);
  });
}
